const CURSOR_CONFIG = {
  sensitivity: 3,
  view: {
    width: 0.06,
    height: 0.087,
    scale: 1.5,
  },
  monitorBottomOffsetToNotTransferCursor: 0.06,
  offsetZFromScreen: 0.01,
  clickCircleOffsetZFromScreen: 0.005,
  hideTimeWhenFullscreenVideo: 1300,
}

export { CURSOR_CONFIG };
